import React, { memo } from 'react'
import { Typography } from 'antd'
import { flatten, isEmpty, map } from 'lodash'
import PropTypes from 'prop-types'

import { StyledAiHighlightedText } from '../../../common/components/styled'
import { AI_HIGHLIGHT_STYLES } from '../../../common/constants'

import {
  StyledIngredientExplanationContainer,
  StyledIngredientExplanationParagraph,
} from '../styled'

const DishDetailsIngredientOverrides = ({ ingredientOverrides }) => {
  if (isEmpty(ingredientOverrides)) {
    return null
  }

  return (
    <>
      <Typography.Paragraph strong>Ingredient overrides</Typography.Paragraph>
      <StyledIngredientExplanationContainer>
        {map(ingredientOverrides, ({ namePath, overriden }) =>
          flatten(
            map(overriden, ({ word }) => (
              <StyledIngredientExplanationParagraph
                key={`overridenRow-${word}-${namePath}`}
              >
                <StyledAiHighlightedText
                  highlights={[AI_HIGHLIGHT_STYLES.negativeSynonym.value]}
                >
                  {word}
                </StyledAiHighlightedText>{' '}
                - {namePath}
              </StyledIngredientExplanationParagraph>
            )),
          ),
        )}
      </StyledIngredientExplanationContainer>
    </>
  )
}

DishDetailsIngredientOverrides.propTypes = {
  ingredientOverrides: PropTypes.arrayOf(
    PropTypes.shape({
      namePath: PropTypes.string,
      overriden: PropTypes.arrayOf({
        word: PropTypes.string,
      }),
    }),
  ).isRequired,
}

export default memo(DishDetailsIngredientOverrides)
